module.exports = __webpack_public_path__ + "img/LUB00370.bf8b1e25.svg";